import { useContext } from "react";
import useMediaWithInitialState from "~/lib/hooks/useMediaWithInitialState";
import MobileDetectContext from "~/components/MobileDetectContext";

export default function useIsMobile() {
  const mobileDetectContext = useContext(MobileDetectContext);
  const isMobile =
    typeof window !== "undefined"
      ? useMediaWithInitialState("(max-width: 960px)")
      : mobileDetectContext.isPhone || mobileDetectContext.isTablet;

  return isMobile;
}
